import axios, { AxiosResponse } from "axios";
import { api } from "../../data/urls";
import returnAuthHeaderForAJAX from "../auth/returnAuthHeaderForAJAX";

type DeleteWebsiteAsync = (payload: {
  accessToken: string;
  subdomain: string;
}) => Promise<AxiosResponse<any>>;

export const deleteWebsiteAsync: DeleteWebsiteAsync = ({
  accessToken,
  subdomain,
}) => {
  return new Promise((resolve, reject) => {
    const apiUrl = `${api.websites.deleteWebsite.prefix}${subdomain}${api.websites.deleteWebsite.postfix}`;
    axios
      .delete(apiUrl, { ...returnAuthHeaderForAJAX(accessToken) })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
